import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-notification-thanks',
  templateUrl: './notification-thanks.component.html',
  styleUrls: ['./notification-thanks.component.scss']
})
export class NotificationThanksComponent implements OnInit {

  showLabel:any=''
  action:any=''
  constructor( public matDialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data :any ) { }

  ngOnInit() {
    this.action = this.data.text;
 if(this.data.text == 'feeedbackthanks'){
      this.showLabel= 'Thank you for sharing your feedback with us. It will greatly help us in improving our future events.'
    }else if(this.data.text == 'eventFormSubmission'){
      this.showLabel= 'Thank you for registering for the event. Your registration is confirmed.'
    }

  }

  onCloseDialog(){
    this.onYesClick('feeedbackthanks')
  }

  onYesClick(val:any){
    if(val == 'feeedbackthanks' || val == 'eventFormSubmission'){
      this.matDialogRef.close('yes');
    }else{
      this.matDialogRef.close('');
    }
   
  }


}
